export default "__VITE_ASSET__b8029033__"